import { Job } from "./types";
import { apiEndpoints } from "../api-config";
import { requestJson } from "../http";

const normalise = (job: any): Job => ({
  system: { id: String(job?.system?.id ?? "") },
  details: {
    ...(job?.details ?? {}),
    jobTitle: job?.details?.jobTitle || "Untitled role",
    skills: Array.isArray(job?.details?.skills) ? job.details.skills : [],
  },
});

/** The company's open, public jobs. Throws ApiError on failure. */
export const getJobs = async (slug: string): Promise<Job[]> => {
  const body = await requestJson<{ data: any[] }>(apiEndpoints(slug).jobs);
  return (body?.data ?? []).map(normalise);
};

/** One open, public job. Throws ApiError(404) if it is not available. */
export const getJobById = async (slug: string, id: string): Promise<Job> => {
  const body = await requestJson<{ data: any }>(apiEndpoints(slug).job(id));
  return normalise(body?.data);
};
